import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui/icon'
import { useLockMeeting } from '../model/use-lock-meeting'

interface LockMeetingControlProps {
  meetingId: string
  locked: boolean
}

// Замок в шапке панели звонка: закрытый звонок отправляет входящих в лобби,
// включая сотрудников. Щёлкается прямо во время разговора и никого из комнаты
// не выселяет. Размер — как у соседних кнопок шапки, не как у контролов тулбара:
// это переключатель режима, а не основное действие звонка.
export function LockMeetingControl({ meetingId, locked }: LockMeetingControlProps) {
  const lock = useLockMeeting(meetingId)
  const label = locked ? 'Открыть звонок' : 'Закрыть звонок'

  return (
    <button
      type="button"
      aria-label={label}
      aria-pressed={locked}
      title={label}
      disabled={lock.isPending}
      onClick={() => lock.mutate(!locked)}
      className={cn(
        'shrink-0 rounded-control px-2 py-1.5 transition-colors disabled:opacity-40',
        locked ? 'text-text-primary' : 'text-text-secondary hover:text-text-primary',
      )}
    >
      <Icon name={locked ? 'lock' : 'unlock'} size={18} />
    </button>
  )
}
